import classnames from 'classnames';
import _ from 'lodash';
import { DateTime } from 'luxon';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import api from 'utils/api';

import Footer from 'components/Footer';
import MaxWidthContainer from 'components/MaxWidthContainer';
import Menubar from 'components/Menubar';
import MobileTabBar from 'components/MobileTabBar';

import { useAppLaunch } from 'contexts/AppLaunch';
import { useUserAuth } from 'contexts/UserAuth';
import { NextSeo } from 'next-seo';
import { getAgeRange, getGenderName } from 'utils/staticContent';
const PublicProfile = (props) => {
  const router = useRouter();
  const { user } = useUserAuth();
  const { sorraUser, seoDescription = '' } = props;
  const { query } = router;
  const { referralCode } = query;
  const {
    name,
    picture,
    age_range,
    birth_year,
    gender,
    skin_factors,
    reviews,
  } = sorraUser;
  const shortName = _.isEmpty(name)
    ? ''
    : `${name.split('')[0] || ''}${(name.split(' ')[1] && name.split(' ')[1].split('')[0]) || ''}`;

  const isMyPersonalPage = user && user.referral_code === referralCode;
  // console.log({ sorraUser });
  const {
    isLoading: isAppLaunchLoading,
    firstCategoryMap,
    secondCategoryMap,
    activityTagMap,
    factorMap,
    notifications,
  } = useAppLaunch();

  // console.log({ skin_factors, secondCategoryMap });
  const factor_names = _.map(skin_factors, (factor) => {
    return factorMap[factor] ? factorMap[factor].name : null;
  });

  const des = _.compact([
    ...factor_names,
    birth_year || age_range
      ? `${getAgeRange(birth_year)?.name || age_range}歲`
      : null,
    !_.isNil(gender) ? getGenderName(gender) : null,
    reviews.length ? `留言數 ${reviews.length}` : null,
  ]).join(' \u00A0|\u00A0 ');

  const reviewScoreCount = _.reduce(
    reviews,
    (acc, review) => {
      const { score } = review;
      if (score == 1) {
        acc.good += 1;
      } else if (score == 0) {
        acc.neutral += 1;
      } else if (score == -1) {
        acc.bad += 1;
      }
      return acc;
    },
    { good: 0, neutral: 0, bad: 0 }
  );

  const [reviewFilter, setReviewFilter] = React.useState(null);
  const reviewFilterOptions = [
    {
      name: '全部',
      count: reviews.length,
      filter: null,
    },
    {
      name: '❤️好評',
      count: reviewScoreCount.good,
      filter: 1,
    },
    {
      name: '👌中性',
      count: reviewScoreCount.neutral,
      filter: 0,
    },
    {
      name: '👿差評',
      count: reviewScoreCount.bad,
      filter: -1,
    },
  ];

  return (
    <div>
      <NextSeo
        title={`讀者【${name}】化妝品使用評價｜真實用後體驗｜Sorra`}
        description={`讀者 【${name}】| ${seoDescription || des}`}
      />
      {!isAppLaunchLoading && (
        <Menubar
          props={{
            homeExtend: false,
            notifications: notifications,
            sourceUI: 'PublicProfile',
          }}
        />
      )}
      <div
        className={
          'globals-centerContentsMargin relative' +
          (notifications && notifications.length > 0 ? ' withNoti' : '')
        }
      >
        <MaxWidthContainer>
          <div className="flex flex-col items-stretch gap-y-6 px-4 py-6 lg:flex-row lg:items-start lg:px-[128px] lg:py-10">
            <div className="flex min-w-0 grow flex-row items-center gap-x-4">
              <div className="h-[64px] w-[64px] overflow-hidden rounded-full">
                {_.isEmpty(picture) ? (
                  <div className="flex h-full w-full items-center justify-center bg-[#D6DDFB]">
                    <p className="text-2xl font-bold text-[#5882FF]">
                      {shortName || ''}
                    </p>
                  </div>
                ) : (
                  <img src={picture} className="h-full w-full object-cover" />
                )}
              </div>
              <h1 className="sr-only">讀者【{name}】美妝真實體驗</h1>
              <div className="flex flex-col gap-y-1">
                <p className="text-lg font-bold text-[#111928]">{name}</p>
                <p className="text-sm text-gray-800">{des}</p>
              </div>
            </div>
            <Link
              prefetch={false}
              href="/profile"
              className="flex flex-shrink-0 items-center justify-center gap-x-3 rounded-lg border border-sorra-pink px-5 py-3 text-base font-medium text-sorra-pink lg:mx-0 lg:py-2.5 lg:text-sm"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18C7.87827 18 5.84344 17.1571 4.34315 15.6569C2.84285 14.1566 2 12.1217 2 10C2 7.87827 2.84285 5.84344 4.34315 4.34315C5.84344 2.84285 7.87827 2 10 2C12.1217 2 14.1566 2.84285 15.6569 4.34315C17.1571 5.84344 18 7.87827 18 10ZM12 7C12 7.53043 11.7893 8.03914 11.4142 8.41421C11.0391 8.78929 10.5304 9 10 9C9.46957 9 8.96086 8.78929 8.58579 8.41421C8.21071 8.03914 8 7.53043 8 7C8 6.46957 8.21071 5.96086 8.58579 5.58579C8.96086 5.21071 9.46957 5 10 5C10.5304 5 11.0391 5.21071 11.4142 5.58579C11.7893 5.96086 12 6.46957 12 7ZM10 11C9.0426 10.9998 8.10528 11.2745 7.29942 11.7914C6.49356 12.3083 5.85304 13.0457 5.454 13.916C6.01668 14.5706 6.71427 15.0958 7.49894 15.4555C8.28362 15.8152 9.13681 16.0009 10 16C10.8632 16.0009 11.7164 15.8152 12.5011 15.4555C13.2857 15.0958 13.9833 14.5706 14.546 13.916C14.147 13.0457 13.5064 12.3083 12.7006 11.7914C11.8947 11.2745 10.9574 10.9998 10 11Z"
                  fill="#F16B7C"
                />
              </svg>
              <p>前往個人中心</p>
            </Link>
          </div>
        </MaxWidthContainer>
        <div className="h-px w-full bg-gray-100" />
        <MaxWidthContainer>
          <div className="flex flex-col px-4 py-4 lg:px-[128px] lg:py-10">
            <p className="text-xl font-bold text-[#111928] lg:text-2xl">
              我用過的({reviews.length})
            </p>
            <div className="flex flex-row justify-between gap-x-2.5 py-4 text-base font-normal lg:justify-start lg:gap-x-4 lg:pt-5 lg:font-medium">
              {reviewFilterOptions.map((option, idx) => {
                const { filter } = option;
                return (
                  <button
                    key={idx}
                    className={classnames(
                      'rounded-full px-4 py-2',
                      idx === 0 ? 'hidden lg:block' : 'block',
                      reviewFilter === filter
                        ? 'bg-gray-800 text-white'
                        : 'bg-gray-50 text-gray-800'
                    )}
                    onClick={() => {
                      if (reviewFilter === filter) {
                        setReviewFilter(null);
                      } else {
                        setReviewFilter(filter);
                      }
                    }}
                  >
                    {option.name} ({option.count})
                  </button>
                );
              })}
            </div>
            <div className="grid grid-cols-1 gap-4 lg:grid-cols-3 lg:gap-2.5">
              {_.filter(reviews, (r) => {
                if (_.isNull(reviewFilter)) {
                  return true;
                } else {
                  return r.score === reviewFilter;
                }
              }).map((review, idx) => {
                const {
                  product,
                  comment,
                  score,
                  is_real_cert,
                  is_activity,
                  cert_images,
                  comparison_images,
                  created_at,
                } = review;
                const { images } = product;
                const productImageUrl = _.head(images)
                  ? _.head(images).url
                  : null;
                return (
                  <div
                    key={review.id}
                    className="flex cursor-pointer flex-col rounded-2xl bg-gray-50 p-4"
                    onClick={() => {
                      const url = `/product/${product.id}`;
                      router.push(url);
                    }}
                  >
                    <h2 className="sr-only">
                      【{_.get(product, 'brand.name')}{' '}
                      {_.get(product, 'en_name')} {_.get(product, 'name')}】
                      使用評價
                    </h2>
                    <div className="flex flex-row items-center gap-x-4 rounded-[10px] bg-white p-2.5">
                      <div className="h-[66px] w-[66px] flex-shrink-0 overflow-hidden rounded">
                        <img
                          src={
                            productImageUrl ||
                            '/images/placeholders/product.png'
                          }
                          className="h-full w-full object-cover"
                        />
                      </div>
                      <div className="flex min-w-0 flex-grow flex-col text-sm font-medium text-[#111928]">
                        <p className="truncate text-xs font-normal text-gray-800">
                          {_.get(product, 'brand.name')}
                        </p>
                        <p className="truncate">{_.get(product, 'en_name')}</p>
                        <p className="truncate">{_.get(product, 'name')}</p>
                        {/* <p className="text-sm text-gray-800">{product.brand}</p> */}
                      </div>
                    </div>
                    <div className="mt-[14px] grow">
                      <div className="flex flex-wrap items-center gap-2 text-base">
                        <p>
                          {_.find(reviewFilterOptions, { filter: score }) &&
                            _.find(reviewFilterOptions, { filter: score }).name}
                        </p>
                        {is_real_cert ? (
                          <p className="rounded-md bg-[#D6DDFB80] px-2 py-1 text-xs text-sorra-blue">
                            真實用家認證
                          </p>
                        ) : null}
                        {is_activity ? (
                          <p className="rounded-md bg-[#FFDCC680] px-2 py-1 text-xs text-[#FFA66D]">
                            試用品
                          </p>
                        ) : null}
                      </div>
                      <div className="mt-2.5 break-words text-base text-[#111928]">
                        {comment}
                      </div>
                      {[...cert_images, ...comparison_images].length > 0 && (
                        <div className="mt-4 flex gap-2.5">
                          {[...cert_images, ...comparison_images].map(
                            (item) => (
                              <div
                                key={item.id}
                                className="h-[70px] w-[70px] overflow-hidden rounded"
                              >
                                <img
                                  src={item.url}
                                  className="h-full w-full object-cover"
                                />
                              </div>
                            )
                          )}
                        </div>
                      )}
                    </div>
                    <p className="mt-5 text-xs text-gray-800">
                      {`${DateTime.fromISO(created_at).toFormat('dd/MM/yyyy hh:mm')}`}{' '}
                      在 Sorra官網 評價
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </MaxWidthContainer>
        <div className="pt-6 lg:pt-24"></div>
        <Footer />
        <MobileTabBar
          props={{ highlighted: isMyPersonalPage ? 'personal' : '' }}
        />
      </div>
    </div>
  );
};

export default PublicProfile;

export async function getServerSideProps(ctx) {
  const { referralCode, alias } = ctx.params;

  try {
    const [{ data: sorraUser }, appLaunchRes] = await Promise.all([
      api.request({
        method: 'get',
        url: `/api/v3/public/profile`,
        params: { referralCode },
      }),
      api
        .request({ method: 'get', url: `/api/v2/appLaunch` })
        .catch(() => null),
    ]);

    // Build factorMap from appLaunch data for SEO description
    let seoDescription = '';
    if (appLaunchRes?.data) {
      const factorTypes = appLaunchRes.data.factor_types || [];
      const factors = _.reduce(
        factorTypes,
        (acc, ft) => acc.concat(ft.factors),
        []
      );
      const factorMap = _.keyBy(factors, 'id');
      const factorNames = _.compact(
        _.map(sorraUser.skin_factors, (f) => factorMap[f]?.name)
      );
      seoDescription = _.compact([
        ...factorNames,
        sorraUser.birth_year || sorraUser.age_range
          ? `${getAgeRange(sorraUser.birth_year)?.name || sorraUser.age_range}歲`
          : null,
        !_.isNil(sorraUser.gender) ? getGenderName(sorraUser.gender) : null,
        sorraUser.reviews?.length ? `留言數 ${sorraUser.reviews.length}` : null,
      ]).join(' \u00A0|\u00A0 ');
    }

    const { is_name_public } = sorraUser;
    const buildProps = { sorraUser, seoDescription };

    if (is_name_public) {
      const { path_name } = sorraUser;
      if (_.isEmpty(alias) || alias != path_name) {
        return {
          redirect: {
            permanent: false,
            destination: `/p/${referralCode}/${path_name}`,
          },
        };
      }
      return { props: buildProps };
    } else {
      if (_.isEmpty(alias)) {
        return { props: buildProps };
      } else {
        return {
          redirect: {
            permanent: false,
            destination: `/p/${referralCode}`,
          },
        };
      }
    }
  } catch (e) {
    console.log({ e });
    return {
      notFound: true,
    };
  }
}
